import React, { useEffect, useState } from 'react';
import { useLanguage } from './LanguageContext';
export function LanguageSelector() {
  const {
    setLanguage
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const [selectedLang, setSelectedLang] = useState<'es' | 'pt' | null>(null);
  // Removido el useEffect que ocultaba la pantalla si ya había un idioma guardado
  // para que siempre aparezca la opción de elegir idioma al entrar a la página.
  if (!isVisible) return null;
  const handleSelect = (lang: 'es' | 'pt') => {
    setSelectedLang(lang);
    setLanguage(lang);
    setIsExiting(true);
    // Remove from DOM quickly
    setTimeout(() => {
      setIsVisible(false);
    }, 300);
  };
  return <div className={`fixed inset-0 z-[100] flex items-center justify-center transition-opacity duration-300 ease-in-out ${isExiting ? 'opacity-0' : 'opacity-100'}`} data-id="element-149">
      {/* Background */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-150"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_50%,rgba(0,0,0,0.08)_100%)] pointer-events-none" data-id="element-151"></div>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden" data-id="element-152">
        <span className="font-serif text-[40vw] leading-none text-[#D4AF37] opacity-[0.03] select-none" data-id="element-153">
          IO
        </span>
      </div>

      {/* Card */}
      <div className={`relative z-10 w-[calc(100%-40px)] max-w-[560px] p-10 md:px-[72px] md:py-[64px] rounded-[32px] flex flex-col items-center text-center transition-transform duration-500 ease-in ${isExiting ? 'scale-90' : 'scale-100'}`} style={{
      background: 'rgba(255, 255, 255, 0.65)',
      backdropFilter: 'blur(24px) saturate(180%)',
      WebkitBackdropFilter: 'blur(24px) saturate(180%)',
      border: '1px solid rgba(212, 175, 55, 0.30)',
      boxShadow: '0 16px 56px rgba(184, 134, 11, 0.12)'
    }} data-id="element-154">
        <h1 className="font-serif text-[42px] text-[#2C1810] tracking-[0.15em] font-light leading-none mb-6" data-id="element-155">
          Iara Oliver
        </h1>

        <div className="flex items-center justify-center text-[#D4AF37] mb-8 w-[100px]" data-id="element-156">
          <div className="flex-1 h-[1px] bg-[#D4AF37]" data-id="element-157"></div>
          <span className="mx-3 text-lg" data-id="element-158">✦</span>
          <div className="flex-1 h-[1px] bg-[#D4AF37]" data-id="element-159"></div>
        </div>

        <h2 className="font-serif italic text-2xl text-[#5C3D2E] mb-4 flex flex-col md:flex-row items-center justify-center gap-2" data-id="element-160">
          <span data-id="element-161">Elegí tu idioma</span>
          <span className="hidden md:inline text-[#D4AF37]" data-id="element-162">·</span>
          <span data-id="element-163">Escolha seu idioma</span>
        </h2>

        <p className="font-sans text-[13px] text-[#8B6355] max-w-[380px] mb-10 leading-relaxed" data-id="element-164">
          Seleccioná el idioma en el que querés ver el contenido · Selecione o
          idioma em que deseja ver o conteúdo
        </p>

        <div className="flex flex-col md:flex-row gap-5 w-full mb-8" data-id="element-165">
          {/* ES Button */}
          <button onClick={() => handleSelect('es')} className={`flex-1 h-[120px] rounded-[20px] flex flex-col items-center justify-center transition-all duration-300 ${selectedLang === 'es' ? 'bg-gold-gradient border-2 border-[#D4AF37] shadow-[0_8px_28px_rgba(212,175,55,0.45)] scale-105 text-white' : selectedLang === 'pt' ? 'bg-white/80 border-[1.5px] border-[#D4AF37]/35 shadow-[0_4px_16px_rgba(0,0,0,0.06)] opacity-40' : 'bg-white/80 border-[1.5px] border-[#D4AF37]/35 shadow-[0_4px_16px_rgba(0,0,0,0.06)] hover:bg-gold-gradient hover:border-transparent hover:shadow-[0_8px_28px_rgba(212,175,55,0.45)] hover:-translate-y-1 hover:scale-[1.03] group'} relative overflow-hidden`} data-id="element-166">
            {selectedLang === 'es' && <span className="absolute top-3 right-3 text-white text-lg" data-id="element-167">
                ✓
              </span>}
            <span className="text-[40px] mb-2.5 leading-none" data-id="element-168">🇦🇷</span>
            <span className={`font-serif text-[22px] font-semibold tracking-[0.2em] uppercase ${selectedLang === 'es' ? 'text-white' : 'text-[#2C1810] group-hover:text-white'}`} data-id="element-169">
              ESPAÑOL
            </span>
            <span className={`font-sans text-[11px] tracking-[0.15em] mt-1 ${selectedLang === 'es' ? 'text-white/85' : 'text-[#8B6355] group-hover:text-white/85'}`} data-id="element-170">
              Continuar →
            </span>
          </button>

          {/* PT Button */}
          <button onClick={() => handleSelect('pt')} className={`flex-1 h-[120px] rounded-[20px] flex flex-col items-center justify-center transition-all duration-300 ${selectedLang === 'pt' ? 'bg-gold-gradient border-2 border-[#D4AF37] shadow-[0_8px_28px_rgba(212,175,55,0.45)] scale-105 text-white' : selectedLang === 'es' ? 'bg-white/80 border-[1.5px] border-[#D4AF37]/35 shadow-[0_4px_16px_rgba(0,0,0,0.06)] opacity-40' : 'bg-white/80 border-[1.5px] border-[#D4AF37]/35 shadow-[0_4px_16px_rgba(0,0,0,0.06)] hover:bg-gold-gradient hover:border-transparent hover:shadow-[0_8px_28px_rgba(212,175,55,0.45)] hover:-translate-y-1 hover:scale-[1.03] group'} relative overflow-hidden`} data-id="element-171">
            {selectedLang === 'pt' && <span className="absolute top-3 right-3 text-white text-lg" data-id="element-172">
                ✓
              </span>}
            <span className="text-[40px] mb-2.5 leading-none" data-id="element-173">🇧🇷</span>
            <span className={`font-serif text-[22px] font-semibold tracking-[0.2em] uppercase ${selectedLang === 'pt' ? 'text-white' : 'text-[#2C1810] group-hover:text-white'}`} data-id="element-174">
              PORTUGUÊS
            </span>
            <span className={`font-sans text-[11px] tracking-[0.15em] mt-1 ${selectedLang === 'pt' ? 'text-white/85' : 'text-[#8B6355] group-hover:text-white/85'}`} data-id="element-175">
              Continuar →
            </span>
          </button>
        </div>

        <p className="font-sans text-[11px] text-[#B0948A] italic flex flex-col gap-1" data-id="element-176">
          <span data-id="element-177">Podés cambiar el idioma en cualquier momento</span>
          <span data-id="element-178">Você pode alterar o idioma a qualquer momento</span>
        </p>
      </div>
    </div>;
}